import React, { useState } from "react";
import { bulan, tahun, constantNoMesin } from "../../util/constant";

const AREAS = [
  "Area Meja kerja",
  "Area Mesin (depan/belakang)",
  "Area Bawah mesin",
  "Lantai",
  "Tempat Produk OK",
  "Tempat Produk NG",
  "Papan Informasi",
];

const SHIFTS = [1, 2, 3];
const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

const sampleChecklistData = [];
const sampleOperators = [];

function symbolFor(value) {
  if (value === true) return "\u2713";
  if (value === false) return "x";
  return "";
}

function nextValue(current) {
  if (current === undefined) return true;
  if (current === true) return false;
  return undefined;
}

function makeKey(tanggal, shift, area) {
  return `${tanggal}-${shift}-${area}`;
}

function makeShiftKey(tanggal, shift) {
  return `${tanggal}-${shift}`;
}

const FormChecklist5R = ({
  formCode = "Form-PROD-A45-R1",
  tim: timProp = "1",
  mesin: mesinProp = "",
  bulanValue: bulanProp = "",
  tahunValue: tahunProp = "",
  data = sampleChecklistData,
  operatorData = sampleOperators,
  currentUserName = "",
  readOnly = false,
  lockedShiftCells = [],
  todayDate = null,
  onSubmit,
  onHeaderChange,
}) => {
  const [tim, setTim] = useState(timProp);
  const [mesin, setMesin] = useState(mesinProp);
  const [bulanExport, setBulanExport] = useState(bulanProp);
  const [tahunExport, setTahunExport] = useState(tahunProp);

  function updateHeader(next) {
    onHeaderChange &&
      onHeaderChange({
        tim,
        mesin,
        bulan: bulanExport,
        tahun: tahunExport,
        ...next,
      });
  }

  const [cekMap, setCekMap] = useState(() => {
    const map = {};
    data.forEach((d) => {
      map[makeKey(d.tanggal, d.shift, d.area)] = d.value;
    });
    return map;
  });

  const [opMap, setOpMap] = useState(() => {
    const map = {};
    operatorData.forEach((o) => {
      map[`${o.tanggal}-${o.shift}`] = o.nama;
    });
    return map;
  });

  const [submitting, setSubmitting] = useState(false);

  const daysToShow = DAYS;

  const lockedShiftCellsSet = new Set(lockedShiftCells.map(String));

  function isShiftLocked(day, shift) {
    return lockedShiftCellsSet.has(makeShiftKey(day, shift));
  }

  function getMissingCells() {
    const missing = [];
    if (!todayDate) return missing;

    SHIFTS.forEach((shift) => {
      if (isShiftLocked(todayDate, shift)) return;

      AREAS.forEach((area) => {
        const v = cekMap[makeKey(todayDate, shift, area)];
        if (v === undefined) {
          missing.push({ day: todayDate, shift, area });
        }
      });
    });
    return missing;
  }

  function handleCellClick(day, shift, area) {
    if (readOnly || isShiftLocked(day, shift)) return;

    const key = makeKey(day, shift, area);
    const newValue = nextValue(cekMap[key]);
    const updatedCekMap = { ...cekMap, [key]: newValue };
    setCekMap(updatedCekMap);

    const stillHasData = AREAS.some(
      (a) => updatedCekMap[makeKey(day, shift, a)] !== undefined
    );

    if (stillHasData) {
      if (currentUserName) {
        setOpMap((prev) => ({
          ...prev,
          [`${day}-${shift}`]: currentUserName,
        }));
      }
    } else {
      setOpMap((prev) => {
        const copy = { ...prev };
        delete copy[`${day}-${shift}`];
        return copy;
      });
    }
  }

  function buildPayload() {
    const checklist = Object.entries(cekMap)
      .filter(([, v]) => v !== undefined)
      .map(([key, value]) => {
        const [tanggal, shift, ...areaParts] = key.split("-");
        return {
          tanggal: Number(tanggal),
          shift: Number(shift),
          area: areaParts.join("-"),
          value,
        };
      });
    const operators = Object.entries(opMap)
      .filter(([, nama]) => nama)
      .map(([key, nama]) => {
        const [tanggal, shift] = key.split("-");
        return { tanggal: Number(tanggal), shift: Number(shift), nama };
      });
    return {
      header: { tim, mesin, bulan: bulanExport, tahun: tahunExport },
      checklist,
      operators,
    };
  }

  async function handleKirim() {
    if (!onSubmit) return;

    if (!mesin || !bulanExport || !tahunExport) {
      alert("Mohon lengkapi Mesin, Bulan, dan Tahun terlebih dahulu.");
      return;
    }

    const missing = getMissingCells();
    if (missing.length > 0) {
      const contoh = missing
        .slice(0, 5)
        .map((m) => `Shift ${m.shift}, ${m.area}`)
        .join("\n");
      const sisa =
        missing.length > 5 ? `\n...dan ${missing.length - 5} lainnya` : "";
      alert(
        `Masih ada ${missing.length} item checklist tanggal ${todayDate} yang belum diisi:\n\n${contoh}${sisa}\n\nMohon lengkapi semua sebelum mengirim.`
      );
      return;
    }

    try {
      setSubmitting(true);
      await onSubmit(buildPayload());
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.headerRow}>
        <div>
          <div style={styles.formCode}>{formCode}</div>
          <div style={styles.timBox}>
            <div style={styles.timLabel}>TIM</div>
            <input
              style={styles.timInput}
              value={tim}
              disabled={readOnly}
              onChange={(e) => {
                setTim(e.target.value);
                updateHeader({ tim: e.target.value });
              }}
            />
          </div>
        </div>
        <h1 style={styles.title}>CHECKLIST 2R</h1>
        <div style={{ width: 90 }} />
      </div>

      <div style={styles.metaRow}>
        <label style={styles.metaLabel}>
          <strong>Mesin :</strong>
          <select
            value={mesin}
            disabled={readOnly}
            onChange={(e) => {
              const val = Number(e.target.value);
              setMesin(val);
              updateHeader({ mesin: val });
            }}
            className="input_select_memo_ppic"
            style={styles.metaSelect}
          >
            <option value="" disabled>
              No Mesin
            </option>
            {constantNoMesin.map((no) => (
              <option key={no} value={no}>
                {no}
              </option>
            ))}
          </select>
        </label>

        <label style={styles.metaLabel}>
          <strong>Bulan :</strong>
          <select
            value={bulanExport}
            disabled={readOnly}
            onChange={(e) => {
              const val = Number(e.target.value);
              setBulanExport(val);
              updateHeader({ bulan: val });
            }}
            className="input_select_memo_ppic"
            style={styles.metaSelect}
          >
            <option value="" disabled>
              Bulan
            </option>
            {bulan.map((ele) => (
              <option key={ele.value} value={ele.value}>
                {ele.name}
              </option>
            ))}
          </select>
        </label>

        <label style={styles.metaLabel}>
          <strong>Tahun :</strong>
          <select
            value={tahunExport}
            disabled={readOnly}
            onChange={(e) => {
              const val = e.target.value;
              setTahunExport(val);
              updateHeader({ tahun: val });
            }}
            className="input_select_memo_ppic"
            style={styles.metaSelect}
          >
            <option value="" disabled>
              Tahun
            </option>
            {tahun.map((th) => (
              <option key={th} value={th}>
                {th}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={{ ...styles.th, ...styles.stickyCol, minWidth: 98 }}>
                Tgl.
              </th>
              {daysToShow.map((day) => (
                <th
                  key={day}
                  colSpan={3}
                  style={{
                    ...styles.th,
                    background:
                      day === todayDate ? "#fff6cc" : styles.th.background,
                  }}
                  title={day === todayDate ? "Tanggal hari ini" : ""}
                >
                  {day}
                </th>
              ))}
            </tr>
            <tr>
              <th style={{ ...styles.th, ...styles.stickyCol }}>Shift</th>
              {daysToShow.map((day) =>
                SHIFTS.map((s) => {
                  const shiftLocked = isShiftLocked(day, s);
                  return (
                    <th
                      key={`${day}-${s}`}
                      style={{
                        ...styles.thShift,
                        background: shiftLocked
                          ? "#ddd"
                          : styles.thShift.background,
                      }}
                      title={shiftLocked ? "Shift ini sudah pernah diisi" : ""}
                    >
                      {s}
                    </th>
                  );
                })
              )}
            </tr>
            <tr>
              <th style={{ ...styles.th, ...styles.stickyCol }}>Point cek</th>
              {daysToShow.map((day) =>
                SHIFTS.map((s) => (
                  <th key={`${day}-${s}-blank`} style={styles.thShift} />
                ))
              )}
            </tr>
          </thead>
          <tbody>
            {AREAS.map((area) => (
              <tr key={area}>
                <td
                  style={{
                    ...styles.tdLabel,
                    ...styles.stickyCol,
                    fontStyle: area === "Papan Informasi" ? "italic" : "normal",
                  }}
                >
                  {area}
                </td>
                {daysToShow.map((day) =>
                  SHIFTS.map((s) => {
                    const v = cekMap[makeKey(day, s, area)];
                    const shiftLocked = isShiftLocked(day, s);
                    return (
                      <td
                        key={`${day}-${s}-${area}`}
                        style={{
                          ...styles.tdCell,
                          cursor:
                            readOnly || shiftLocked ? "default" : "pointer",
                          color: v === false ? "#c0392b" : "#1b1b1b",
                          fontSize: v === false ? "18px" : "",
                          background: shiftLocked
                            ? "#f0f0f0"
                            : v === true
                            ? "#eefaf0"
                            : v === false
                            ? "#fdecea"
                            : "#fff",
                        }}
                        onClick={() => handleCellClick(day, s, area)}
                        title={
                          shiftLocked
                            ? "Shift ini sudah pernah diisi, tidak bisa diubah"
                            : readOnly
                            ? ""
                            : "Klik untuk ubah: kosong -> v -> x"
                        }
                      >
                        {symbolFor(v)}
                      </td>
                    );
                  })
                )}
              </tr>
            ))}

            <tr>
              <td
                style={{ ...styles.tdLabel, ...styles.stickyCol, height: 60 }}
              >
                Operator (Nama &amp; Paraf)
              </td>
              {daysToShow.map((day) =>
                SHIFTS.map((s) => {
                  const nama = opMap[`${day}-${s}`] || "";
                  return (
                    <td key={`${day}-${s}-op`} style={{ ...styles.tdCellOp }}>
                      {nama}
                    </td>
                  );
                })
              )}
            </tr>
          </tbody>
        </table>
      </div>

      <div style={styles.footerRow}>
        <div style={styles.legend}>
          <div style={styles.legendTitle}>Keterangan :</div>
          <div style={styles.legendLine}>
            <span style={styles.legendSymbol}>{"\u2713"}</span> = Sudah bersih
            dan rapih (Resik &amp; Rapih)
          </div>
          <div style={styles.legendLine}>
            <span style={styles.legendSymbol}>x</span> = Belum Bersih dan
            Rapih/tidak ada tempat produk OK/NG
          </div>
          {lockedShiftCells.length > 0 && (
            <div style={{ ...styles.legendHint, color: "#c0392b" }}>
              Kolom shift berwarna abu-abu sudah pernah diisi &amp; tidak bisa
              diubah lagi.
            </div>
          )}
          {!readOnly && (
            <div style={styles.legendHint}>
              Klik sel untuk mengisi: kosong &rarr; {"\u2713"} &rarr; x &rarr;
              kosong. Semua item di tanggal hari ini (kolom kuning) wajib diisi
              sebelum bisa dikirim.
            </div>
          )}
        </div>

        {!readOnly && (
          <button
            type="button"
            style={{ ...styles.kirimBtn, opacity: submitting ? 0.6 : 1 }}
            disabled={submitting}
            onClick={handleKirim}
          >
            {submitting ? "Mengirim..." : "Kirim"}
          </button>
        )}
      </div>
    </div>
  );
};

export default FormChecklist5R;

// ------------------------------------------------------------------
// STYLES
// ------------------------------------------------------------------
const styles = {
  page: {
    fontFamily: "'Times New Roman', Georgia, serif",
    padding: 20,
    background: "#fff",
    color: "#111",
    maxWidth: 1400,
    margin: "0 auto",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  formCode: { fontSize: 14 },
  timBox: {
    border: "1px solid #333",
    width: 70,
    marginTop: 6,
    textAlign: "center",
  },
  timLabel: {
    background: "#5b8fc7",
    color: "#fff",
    fontWeight: "bold",
    fontSize: 12,
    padding: "2px 0",
  },
  timInput: {
    width: "100%",
    border: "none",
    outline: "none",
    textAlign: "center",
    fontSize: 13,
    padding: "4px 0",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  title: {
    textDecoration: "underline",
    fontSize: 26,
    fontWeight: "bold",
    margin: "0 auto",
    textAlign: "center",
  },
  metaRow: {
    display: "flex",
    gap: 24,
    marginTop: 10,
    marginBottom: 12,
    fontSize: 14,
    alignItems: "center",
    flexWrap: "wrap",
  },
  metaLabel: { display: "flex", gap: 8, alignItems: "center" },
  metaSelect: {
    border: "1px solid #888",
    outline: "none",
    fontSize: 14,
    fontFamily: "inherit",
    padding: "4px 8px",
    minWidth: 130,
    borderRadius: 4,
    background: "#fff",
  },
  tableWrap: { overflowX: "auto", border: "1px solid #333" },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    fontSize: 12,
  },
  th: {
    border: "1px solid #333",
    background: "#e8e8e8",
    padding: "4px 6px",
    textAlign: "center",
    fontWeight: "bold",
  },
  thShift: {
    border: "1px solid #333",
    background: "#f4f4f4",
    padding: "2px 4px",
    minWidth: 22,
    textAlign: "center",
    fontWeight: "bold",
  },
  tdLabel: {
    border: "1px solid #333",
    padding: "4px 8px",
    textAlign: "left",
    background: "#fff",
  },
  tdCell: {
    border: "1px solid #333",
    minWidth: 22,
    height: 26,
    textAlign: "center",
    verticalAlign: "middle",
    userSelect: "none",
    fontWeight: "bold",
    padding: "0",
  },
  tdCellOp: {
    border: "1px solid #333",
    minWidth: 22,
    height: 30,
    textAlign: "center",
    verticalAlign: "middle",
    fontSize: 10,
    paddingTop: 0,
    rotate: "-90deg",
  },
  stickyCol: {
    position: "sticky",
    left: 0,
    background: "#fff",
    zIndex: 2,
  },
  footerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: 14,
    gap: 20,
    flexWrap: "wrap",
  },
  legend: { fontSize: 13, paddingLeft: 20 },
  legendTitle: { fontWeight: "bold", marginBottom: 4 },
  legendLine: { marginLeft: 20 },
  legendSymbol: { display: "inline-block", width: 18, fontWeight: "bold" },
  legendHint: {
    marginLeft: 20,
    marginTop: 6,
    color: "#555",
    fontStyle: "italic",
  },
  kirimBtn: {
    padding: "10px 28px",
    fontSize: 14,
    fontWeight: "bold",
    color: "#fff",
    background: "#2b7a3f",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontFamily: "inherit",
  },
};
